import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { testMatchCheck } from '~/services/ClaimCampaignService';

interface TestMatchCheckParams {
  bqQuery: string;
  eligibilityTemplate: string;
  customerId: string;
}

/**
 * Runs a dry-run match-check with a BQ query and eligibility template.
 */
export function useTestMatchCheck() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (params: TestMatchCheckParams) => {
      return await testMatchCheck(params);
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Match check failed: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
